export default __webpack_public_path__ + "static/mvp-minimum-viable-product-cos-e-perche-e-fondamentale-orangeloop-262faa1177059852a180f7edb0b99f75.jpg";